"use strict";

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

(function () {
  "use strict";

  angular.module("models").constant("authEvents", {
    LOGIN_SUCCESS: "auth_login_success",
    LOGIN_FAILED: "auth_login_failed",
    LOGOUT_SUCCESS: "auth_logout_success",
    LOGOUT_FAILED: "auth_logout_failed",
    SESSION_TIMEOUT: "auth_session_timeout",
    NOT_AUTHENTICATED: "auth_not_authenticated", // backend trigger
    FORBIDDEN: "auth_forbidden", // backend trigger
    NOT_AUTHORIZED: "auth_not_authorized" // frontend trigger
  }).factory("AuthService", AuthService);

  AuthService.$inject = ["UsersService", "CustomersService", "$uibModalStack", "authEvents", "$rootScope", "$state"];

  function AuthService(UsersService, CustomersService, $uibModalStack, authEvents, $rootScope, $state) {
    var _this = this;

    var log = debug("service:auth");

    //var log = Logger.getInstance('authentificationFactory');

    //log.setLevel(ENV[window.__env].levelLog || 6);

    var auth = {};

    $rootScope.$super = false;

    $rootScope.$on(authEvents.NOT_AUTHENTICATED, function (event, error) {
      if ($rootScope.$user && Object.keys($rootScope.$user).length > 0) {
        $uibModalStack.dismissAll("Not authenticated");
        auth.logout();
        swal("", "Session expirée", "error");
      }
    });

    $rootScope.$on(authEvents.FORBIDDEN, function (event, error) {
      if ($rootScope.$user && Object.keys($rootScope.$user).length > 0) {
        $uibModalStack.dismissAll("Forbidden");
        auth.logout();
      }
      // Can be triggered even if not authenticated
      if (error == "NO_BETA_ACCESS_RIGHTS") {
        swal("", "Pas de droits d'accès à la bêta : contacter le support.", "error");
      } else if (error == "INACTIVE_USER") {
        swal("", "Droits d'accès utilisateur inactifs : contacter le support.", "error");
      } else if (error == "INACTIVE_CUSTOMER") {
        swal("", "Droits d'accès client inactifs : contacter le support.", "error");
      } else if (error == "NO_ACCESS_RIGHTS") {
        swal("", "Droits d'accès utilisateur inexistants : contacter le support.", "error");
      } else {
        swal("", "Action interdite", "error");
      }
    });

    $rootScope.$on(authEvents.NOT_AUTHORIZED, function () {
      if ($rootScope.$user && Object.keys($rootScope.$user).length > 0) {
        $uibModalStack.dismissAll("Not authorized");
        auth.logout();
        swal("", "Accès non autorisé !", "error");
      }
    });

    $rootScope.$on("other_error", function (event, error) {
      if (!error.message.startsWith("404")) {
        swal("", error.toString(), "error");
      }
    });

    auth.login = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(email, password, code) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                log("call AuthService.login");

                return _context.abrupt("return", UsersService.login({
                  email: email,
                  password: password,
                  code: code
                }));

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      return function (_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      };
    }();

    // FIX : some errors when perform twice
    auth.logout = function () {
      log("logout!!!");

      $rootScope.$user = null;

      $rootScope.$super = false;

      $rootScope.$admin = false;

      return UsersService.logout().then(function (response) {
        $rootScope.$bus.publish({
          channel: "logout",
          topic: "success",
          data: {}
        });

        log("logout done");

        auth.currentUser = null;

        $state.go("login");
      }).catch(function (err) {
        log("logout err", err);

        $state.go("login");

        $rootScope.$bus.publish({
          channel: "logout",
          topic: "failed",
          data: {}
        });
      });
    };

    auth.isAuthenticated = function () {
      return UsersService.isAuthenticated();
    };

    auth.whoami = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var user, customer;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return UsersService.customGet("whoami");

            case 3:
              user = _context2.sent;


              log("find current user", user);

              // Trigger security check
              _context2.next = 7;
              return CustomersService.getById(user.customerId);

            case 7:
              customer = _context2.sent;


              user.customerName = customer ? customer.name : "???";

              if (!(customer == "?.?" || user.customerName == "???" || !user.customerName)) {
                _context2.next = 13;
                break;
              }

              auth.logout();
              _context2.next = 19;
              break;

            case 13:
              if (!user.rights) {
                user.rights = {
                  resource: {
                    read: false,
                    write: false,
                    delete: false
                  },
                  depa: {
                    read: false,
                    write: false,
                    delete: false
                  },
                  course: {
                    read: false,
                    write: false,
                    delete: false
                  },
                  damage: {
                    read: false,
                    write: false,
                    delete: false
                  }
                };
              }

              $rootScope.$user = user;
              log("Role =" + $rootScope.$user.role);

              _context2.next = 18;
              return auth.checkUser($rootScope.$user);

            case 18:

              $rootScope.$bus.publish({
                channel: "login",
                topic: "success",
                data: {
                  value: $rootScope.$user.customerId.substr(1)
                }
              });

            case 19:
              _context2.next = 26;
              break;

            case 21:
              _context2.prev = 21;
              _context2.t0 = _context2["catch"](0);

              $rootScope.$user = null;
              console.log("user err", _context2.t0);
              $state.go("login");

            case 26:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this, [[0, 21]]);
    }));

    auth.checkUser = function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(user) {
        var customerId, selectedCustomer;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                log("check user:", user);

                if (user.role && (user.role === "super-admin" || user.role === "user-admin")) {
                  $rootScope.$admin = true;
                } else {
                  $rootScope.$admin = false;
                }

                if (user.role && (user.role === "super-admin" || user.role === "super-operator" || user.role === "operator")) {
                  $rootScope.$super = true;
                } else {
                  $rootScope.$super = false;
                }

                if ($rootScope.$super == true) {
                  customerId = localStorage.getItem("$selectedCustomerId");


                  if (customerId) {
                    $rootScope.$selectedCustomerId = customerId;
                  } else {
                    $rootScope.$selectedCustomerId = user.customerId;
                  }
                } else {
                  $rootScope.$selectedCustomerId = user.customerId;
                }
                _context3.next = 6;
                return CustomersService.getById($rootScope.$selectedCustomerId);

              case 6:
                selectedCustomer = _context3.sent;

                $rootScope.defaultManagerLabel = selectedCustomer.defaultManagerLabel ? selectedCustomer.defaultManagerLabel : "Manageur";
                $rootScope.defaultManagerValue = "Manageur";
                $rootScope.qseManagerLabel = selectedCustomer.qseManagerLabel ? selectedCustomer.qseManagerLabel : "Responsable QSE";
                $rootScope.qseManagerValue = "QSE";
                $rootScope.qseManagerHidden = selectedCustomer.qseManagerHidden ? true : false;
                $rootScope.rhManagerLabel = selectedCustomer.rhManagerLabel ? selectedCustomer.rhManagerLabel : "Responsable RH";
                $rootScope.rhManagerValue = "RH";
                $rootScope.rhManagerHidden = selectedCustomer.rhManagerHidden ? true : false;
                $rootScope.fleetManagerLabel = selectedCustomer.fleetManagerLabel ? selectedCustomer.fleetManagerLabel : "Gestionnaire Parc";
                $rootScope.fleetManagerValue = "Gestionnaire Parc";
                $rootScope.fleetManagerHidden = selectedCustomer.fleetManagerHidden ? true : false;
                $rootScope.other1ManagerLabel = selectedCustomer.other1ManagerLabel ? selectedCustomer.other1ManagerLabel : "Autre responsable 1";
                $rootScope.other1ManagerValue = "Autre responsable 1";
                $rootScope.other1ManagerHidden = selectedCustomer.other1ManagerHidden ? true : false;
                $rootScope.other2ManagerLabel = selectedCustomer.other2ManagerLabel ? selectedCustomer.other2ManagerLabel : "Autre responsable 2";
                $rootScope.other2ManagerValue = "Autre responsable 2";
                $rootScope.other2ManagerHidden = selectedCustomer.other2ManagerHidden ? true : false;

                log("$rootScope.$selectedCustomerId=" + $rootScope.$selectedCustomerId);

              case 25:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      return function (_x4) {
        return _ref3.apply(this, arguments);
      };
    }();

    return auth;
  }
})();